import { rootRouteId, useNavigate, useSearch } from '@tanstack/react-router';

export const useShortcutsDialog = () => {
    const isOpen = useSearch({ from: rootRouteId, select: (search) => Boolean(search.shortcuts) });
    const navigate = useNavigate();

    const open = () =>
        navigate({
            to: '.',
            search: (search) => ({ ...search, shortcuts: true }),
            replace: true,
        });

    const close = () =>
        navigate({
            to: '.',
            search: (search) => ({ ...search, shortcuts: undefined }),
            replace: true,
        });

    const toggle = () => (isOpen ? close() : open());

    return { isOpen, open, close, toggle };
};
